import moment from 'moment'

export const handleStatusString = (deathClaimData, showDatesOnText = true) => {
  const { data, value } = deathClaimData
  switch (value) {
    case 'Salesforce Case Created':
      return {
        text: showDatesOnText ? `Salesforce Case Created (${formatDate(data.SalesforceCaseCreated)})` : 'Salesforce Case Created',
        date: data.SalesforceCaseCreated,
      }

    case 'Carrier Notified of Death':
      return {
        text: showDatesOnText ? `Pending Claim Paperwork from Carrier (${formatDate(data.PendingClaimPaperworkFromCarrier)})` : 'Pending Claim Paperwork from Carrier',
        date: data.PendingClaimPaperworkFromCarrier,
      }

    case 'Received Claim Paperwork from Carrier':
      return {
        text: showDatesOnText ? `BCC Received Claim Paperwork from Carrier (${formatDate(data.BccReceivedClaimPaperworkFromCarrier)})` : 'BCC Received Claim Paperwork from Carrier',
        date: data.BccReceivedClaimPaperworkFromCarrier,
      }

    case 'Claim Paperwork Sent to Client':
      return {
        text: showDatesOnText ? `Bank to Execute Death Claim Packet (${formatDate(data.BankToExecuteDeathClaimPacket)})` : 'Bank to Execute Death Claim Packet',
        date: data.BankToExecuteDeathClaimPacket,
      }

    case 'Claim Paperwork Signed by Client':
      return {
        text: showDatesOnText ? `Bank Returned Death Claim Packet (${formatDate(data.BankReturnedDeathClaimPacket)})` : 'Bank Returned Death Claim Packet',
        date: data.BankReturnedDeathClaimPacket,
      }

    case 'Death Certificate Applied For':
      return {
        text: showDatesOnText ? `Applied for Death Certificate (${formatDate(data.AppliedForDeathCertificate)})` : 'Applied for Death Certificate',
        date: data.AppliedForDeathCertificate,
      }

    case 'Death Certificate Received':
      return {
        text: showDatesOnText ? `Received Death Certificate (${formatDate(data.ReceivedDeathCertificate)})` : 'Received Death Certificate',
        date: data.ReceivedDeathCertificate,
      }

    case 'Claim Kit Sent to Carrier':
      return {
        text: showDatesOnText ? `Death Claim Packet Sent to Carrier (${formatDate(data.DeathClaimPacketSentToCarrier)})` : 'Death Claim Packet Sent to Carrier',
        date: data.DeathClaimPacketSentToCarrier,
      }

    case 'Received Explanation of Benefits and Sent to Service Team':
      return {
        text: showDatesOnText ? `BCC Received Explanation of Benefits (${formatDate(data.BccReceivedExplanationOfBenefits)})` : 'BCC Received Explanation of Benefits',
        date: data.BccReceivedExplanationOfBenefits,
      }

    default:
      return {
        text: showDatesOnText ? `Bank Sent Explanation of Benefits, Case Closed (${formatDate(data.BankSentExplanationOfBenefitsCaseClosed)})` : 'Bank Sent Explanation of Benefits, Case Closed',
        date: data.BankSentExplanationOfBenefitsCaseClosed,
      }
  }
}

export function formatDate(value) {
  if (!value) return ''
  return moment(value).format('MM/DD/YYYY')
}
